import { BATHROOM_PDP_CDN_PATH } from '../../bathroom-pdp-constants';

export const BATHROOM_PDP_CATEGORY_CARD_LIST = [
  {
    name: 'Смесители для ванной комнаты',
    imgSrc: `${BATHROOM_PDP_CDN_PATH}/categories/smesiteli-dlya-vannoy-komnaty.png/smesiteli-dlya-vannoy-komnaty.png`,
    alt: 'Смесители для ванной комнаты',
    link: {
      href: '/catalogue/smesiteli-dlya-vannoy-komnaty/',
      title: 'Смесители для ванной комнаты',
    },
  },
  {
    name: 'Зеркала и\u00A0полки в\u00A0ванную',
    imgSrc: `${BATHROOM_PDP_CDN_PATH}/categories/zerkala-i-polki-v-vannuyu.png/zerkala-i-polki-v-vannuyu.png`,
    alt: 'Зеркало в ванную',
    link: {
      href: '/catalogue/zerkala-i-polki-v-vannuyu/',
      title: 'Зеркала и полки в ванную',
    },
  },
  {
    name: 'Душевое оборудование',
    imgSrc: `${BATHROOM_PDP_CDN_PATH}/categories/dushevoe-oborudovanie.png/dushevoe-oborudovanie.png`,
    alt: 'Душевое оборудование',
    link: {
      href: '/catalogue/dushevoe-oborudovanie/',
      title: 'Душевое оборудование',
    },
  },
  {
    name: 'Текстиль и\u00A0штанги для ванной комнаты',
    imgSrc: `${BATHROOM_PDP_CDN_PATH}/categories/tekstil-i-shtangi-dlya-vannoy-komnaty.png/tekstil-i-shtangi-dlya-vannoy-komnaty.png`,
    alt: 'Полотенца для ванной комнаты',
    link: {
      href: '/catalogue/tekstil-i-shtangi-dlya-vannoy-komnaty/',
      title: 'Текстиль и штанги для ванной комнаты',
    },
  },
  {
    name: 'Аксессуары для ванной комнаты',
    imgSrc: `${BATHROOM_PDP_CDN_PATH}/categories/aksessuary-dlya-vannoy-komnaty.png/aksessuary-dlya-vannoy-komnaty.png`,
    alt: 'Подвесной дозатор для жидкого мыла',
    link: {
      href: '/catalogue/aksessuary-dlya-vannoy-komnaty/',
      title: 'Аксессуары для ванной комнаты',
    },
  },
  {
    name: 'Сушилки и\u00A0гладильные доски',
    imgSrc: `${BATHROOM_PDP_CDN_PATH}/categories/sushilki-i-gladilnye-doski.png/sushilki-i-gladilnye-doski.png`,
    alt: 'Сушилка для белья',
    link: {
      href: '/catalogue/sushilki-i-gladilnye-doski/',
      title: 'Сушилки и гладильные доски',
    },
  },
];
